import { NextSeo } from 'next-seo'

import getHomeContentByUID from '@lib/prismic/fetch/documents'
import sliceResolvers from '@lib/prismic/helpers/sliceResolvers'

import AllSlices from '@components/prismic/AllSlices'
import Slice from '@components/prismic/Slice'

export default function HomePage({ homepage }: { homepage: any }) {
	const slices = homepage?.data?.body || []

	// Check if first two slices are hero + logo slider for above-the-fold layout
	const hasAboveFold =
		slices.length >= 2 &&
		slices[0]?.slice_type === 'gallery_box' &&
		slices[1]?.slice_type === 'logos_slider'

	if (!hasAboveFold) {
		return (
			<>
				<NextSeo title="Beauty Subscriptions and More" />
				<AllSlices body={slices} />
			</>
		)
	}

	return (
		<>
			<NextSeo title="Beauty Subscriptions and More" />
			{/* Above the fold: hero + logo slider fit within viewport on mobile */}
			<div className="flex flex-col h-[calc(100vh-40px)] supports-[height:100svh]:h-[calc(100svh-40px)]">
				<Slice slice={slices[0]} index={0} />
				<Slice slice={slices[1]} index={1} />
			</div>
			{/* Below the fold */}
			<AllSlices body={slices.slice(2)} />
		</>
	)
}

export async function getStaticProps({ previewData }: { previewData: any }) {
	const homepage = await getHomeContentByUID('home_rebrand', previewData)

	if (!homepage) {
		return { notFound: true }
	}

	if (homepage.type === 'home_rebrand') {
		homepage.data.body = (await sliceResolvers(homepage.data.body)) as typeof homepage.data.body
	}

	return {
		props: {
			homepage
		},
		revalidate: 86400
	}
}
